<template>
  <div class="space-y-6 text-center">
    <h3 class="text-xl font-bold">{{ $t("totalForm.gdpr.title") }}</h3>
    <p class="text-sm text-gray-600 max-w-md mx-auto">
      {{ $t("totalForm.gdpr.desc") }}
    </p>
    <div class="space-y-4 max-w-xs mx-auto">
      <button @click="$emit('accept')" class="btn btn-primary w-full">
        {{ $t("totalForm.gdpr.agree") }}
      </button>
      <button @click="$emit('decline')" class="btn btn-outline w-full">
        {{ $t("totalForm.gdpr.decline") }}
      </button>
    </div>
  </div>
</template>
